/**
 * id → display name lookup used by the cloud-data viewer (InventoryTab,
 * HeroesTab) to label items inside player save blobs. Derived from the
 * same items.json the give-item picker uses, so picker entries and
 * inventory labels stay in sync.
 */

import itemsJson from "./items.json";

export const ITEM_NAMES: Record<string, string> = Object.fromEntries(
  (itemsJson as Array<{ id: string; name: string }>).map((it) => [it.id, it.name])
);

export function getItemName(id: string | null | undefined): string {
  if (!id) return "—";
  return ITEM_NAMES[id] ?? id;
}
